import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useToaster } from "src/_common/hooks/actions/common/appToasterHook";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { useTranslation } from "src/_common/hooks/useTranslation";
import { handleApiCall } from "src/_config";

interface SecurityMainProps {}

const SecurityMain: React.FC<SecurityMainProps> = () => {
  const history = useHistory();
  const userApi = useUserApi();
  const toast = useToaster();
  const userSelector = useAppUserDetailsSelector();
  const { t } = useTranslation("member");

  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    userApi.callGetMe(
      () => {},
      () => {},
    );
  }, []);

  useEffect(() => {
    // Get the current 2FA status from user data
    if (userSelector?.user?.two_fa_auth_enabled !== undefined) {
      setTwoFactorEnabled(userSelector.user.two_fa_auth_enabled);
    }
  }, [userSelector]);

  const handleBackClick = () => {
    history.goBack();
  };

  const handleToggleTwoFactor = () => {
    setIsLoading(true);
    const newStatus = !twoFactorEnabled;

    const requestData = {
      two_fa_auth_enabled: newStatus,
    };

    handleApiCall(
      userApi.callUpdateTwoFactorAuth,
      requestData,
      (response: any) => {
        setTwoFactorEnabled(newStatus);
        setIsLoading(false);
      },
      toast,
      true,
      false
    );
  };

  return (
    <div className="dashboard-main member-page-wrapper">
      {/* Header Section */}
      <div className="drjob-page-header">
        <div className="drjob-header-left">
          <button className="back-button d-none" onClick={handleBackClick}>
            {t("members.security.backButton")}
          </button>
          <h1 className="drjob-page-title">{t("members.security.title")}</h1>
        </div>
      </div>

      <div className="drjob-member-list">
        {/* Two-Factor Authentication Section */}
        <div className="drjob-table-container">
          <div className="security-section">
            <div className="security-setting">
              <div className="setting-info">
                <h3 className="setting-title">{t("members.security.twoFactorAuth.title")}</h3>
                <p className="setting-description">{t("members.security.twoFactorAuth.description")}</p>
              </div>
              <div className="setting-action">
                <button
                  className={` ${twoFactorEnabled ? "drjob-submit-btn cancel-btn find-btn" : "btn-preview"}`}
                  onClick={handleToggleTwoFactor}
                  disabled={isLoading}
                >
                  {isLoading ? t("members.security.twoFactorAuth.processingButton") : twoFactorEnabled ? t("members.security.twoFactorAuth.deactivateButton") : t("members.security.twoFactorAuth.activateButton")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityMain;
